<template lang="pug">
d-input-base(
  :component="VSelect"
  v-bind="extendAttrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import DInputBase from './DInputBase.vue';
import { VSelect } from 'vuetify/lib';

export default {
  components:  { DInputBase, VSelect },
  data() {
    return {
      VSelect,
    };
  },
  computed: {
    extendAttrs() {
      return {
        placeholder: 'Выберите...',
        height: 48,
        appendIcon: this.$attrs['append-icon'] ?? '$ui-chevron-down',
        ...this.$attrs,
      };
    },
  },
};
</script>

<!-- <style lang="scss" scoped>
::v-deep .v-select__slot {
  overflow: hidden;
}
</style> -->
